export enum ShippingFileFormat {
  PDF = "PDF",
  ZPL = "ZPL",
  XLS = "XLS",
  PNG = "PNG",
  JPG = "JPG",
  OTHER = "OTHER",
}

export enum ShippingFileType {
  LABEL = "LABEL",
  INVOICE = "INVOICE",
  MANIFEST = "MANIFEST",
  PROOF_OF_DELIVERY = "PROOF_OF_DELIVERY",
  OTHER = "OTHER",
}

export type ShippingFile = {
  id?: string;
  createdAt?: Date;
  updatedAt?: Date;
  name: string | null;
  url: string;
  mainApiMediaId?: string | null;
  type: ShippingFileType;
  format?: ShippingFileFormat;
  shippingRecordId?: string | null;
  shipmentId?: string | null;
  deliveryLocationEntityId?: string | null;
};
